import { render, staticRenderFns } from "./full-guest-card.vue?vue&type=template&id=0d33aea0&"
import script from "./full-guest-card.vue?vue&type=script&lang=ts&"
export * from "./full-guest-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports